const proceduresReducer = (
  state = {
    loading: false,
    exportLoading: false,
    data: null,
    total: null
  },
  action
) => {
  switch (action.type) {
    case "SET_PROCEDURES_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_PROCEDURES_DATA":
      return {
        ...state,
        data: action.payload.data
      };

    case "SET_TOTAL_PROCEDURE_COUNT":
      return {
        ...state,
        total: action.payload
      };

    case "SET_PROCEDURES_EXPORT_LOADING":
      return {
        ...state,
        exportLoading: action.payload.loading
      };

    case "RESET":
      return {
        loading: false,
        exportLoading: false,
        data: null,
        total: null
      };

    default:
      return state;
  }
};
export default proceduresReducer;
